import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNotepad: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="notepad,notes">
      <path
        d="M9 10H15M9 14H13M12 4.5V2.5M16 4.5V2.5M8 4.5V2.5M4.5 3.5H19.5V20.5H4.5V3.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </CentralIconBase>
  );
};

export default IconNotepad;
